export interface Menu {
  link: string;
  title: string;
}

export const buildMenuResponsive = (
  hasServiceFidelisation,
  hasListeProduits,
  hasRemboursement,
  hasRenouvellemement,
  hasResiliation
) => {
  let menu: (Menu | undefined)[] = [];

  if (hasListeProduits) {
    menu.push({
      link: "/contrats?avantage",
      title: "Avantages",
    });
  }
  // not added to menu for [Production]
  if (hasServiceFidelisation && !window.location.hostname.startsWith('part')) {
    menu.push({
      link: "/contrats?fidelite",
      title: "Fidélité",
    });
  }
  if (hasRenouvellemement) {
    menu.push({
      link: "/contrats?renouvellement",
      title: "Renouvellement",
    });
  }
  if (hasRemboursement) {
    menu.push({
      link: "/demande-remboursement",
      title: "Remboursement",
    });
  }
  if (hasResiliation) {
    menu.push({
      link: "/contrats?resiliation",
      title: "Résiliation",
    });
  }
  menu.push({
    link: "/contrats?informations",
    title: "Informations",
  });

  return menu;
};
